import { render, staticRenderFns } from "./CrewMember.vue?vue&type=template&id=6cae268e&"
import script from "./CrewMember.vue?vue&type=script&lang=ts&"
export * from "./CrewMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports